<template>
<div>
<div class="name-card">
  <v-card :color="color" ref="card" :dark="dark" :img="cardBgImage">
    <v-responsive v-if="showTopNav">
      <v-layout row justify-space-between class="ma-0">
        <v-flex xs2>
          <v-icon @click="deleteMember" color="pink">delete</v-icon>
        </v-flex>
        <v-flex xs2 class="text-sm-right">
          <v-icon :id="id" @click="editMember(id)">edit</v-icon>
        </v-flex>
      </v-layout>
    </v-responsive>    
    <v-card-text>
      <div class="layout ma-0 align-center" :class="computeCardLayout">
        <v-avatar :size="computeAvatarSize" color="primary">
          <img v-bind:src="avatar.src" v-bind:alt="firstName" v-if="showAvatar">
          <span v-else class="white--text headline">{{ firstName.charAt(0) }}{{ lastName.charAt(0) }}</span>
        </v-avatar>
        <div class="flex" :class="computeTextAlgin">
          <div class="subheading">{{firstName}} {{lastName}}</div>
          <span class="caption">{{role}}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
  <v-bottom-nav :value="true" color="transparent" :height="64" v-if="showBottomNav">
    <v-dialog
      v-model="showPhone"
      hide-overlay
      width="300"
    >
    <v-btn flat color="balck" slot="activator" value="recent">
      <span>Telephone</span>
      <v-icon>phone</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Numero de Telephone: {{phone}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showEntrees"
      hide-overlay
      width="300"
    >
    <v-btn flat @click="takePhoto(id)" color="black" slot="activator" value="favorites">
      <span>Photo</span>
      <v-icon>add_a_photo</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Donnée totale: {{entrees}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      hide-overlay
      width="300"
    >
    <v-btn @click="previewImage(id)" flat color="black" slot="activator" value="nearby">
      <span>fichier</span>
      <v-icon>attach_file</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Donnée Aujourd'hui: {{todays}}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-bottom-nav>   
</div>
</div>
</template>

<script>
/* eslint-disable */
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    entrees: {
      type: Number,
      default: 0
    },
    todays: {
      type: Number,
      default: 0
    },
    avatar: {
      type: Object,
      default: null
    },
    jobTitle: {
      type: String,
      default: ''
    },
    cardBgImage: {
      type: String,
    },
    color: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    bottomNav: {
      type: Boolean,
      default: false
    },    
    topNav: {
      type: Boolean,
      default: true
    },      
    mini: {
      type: Boolean,
      default: false
    }    
  },
  data: () => ({
    showToday: false,
    showEntrees: false,
    showPhone: false
  }),
  
  computed: {
    computeCardLayout () {
      return (this.mini) ? 'row' : 'column';
    },
    computeTextAlgin () {
      return (this.mini) ? 'text-sm-right' : 'text-sm-center';
    },
    computeAvatarSize () {
      return (this.mini) ? '48' : '96';
    },
    showAvatar () {
      return this.avatar !== null && this.avatar.src;
    },

    showBottomNav () {
      return (this.mini === false && this.bottomNav); 
    },

    showTopNav () {
      return (this.mini === false && this.topNav); 
    }
  },

  methods: {
    editMember (id) {
     this.fetchCurrentMember(id)
    },
    deleteMember (item) {
      const index = this.members.indexOf(item);
      confirm('Etes-vous sûre de vouloir supprimer ce membre?') && this.members.splice(index, 1);
      this.$store.dispatch('deleteMember', item.id);
    },
    takePhoto (id) {
      this.$store.commit('currentMemberId', id);
      this.$router.push('/appphoto');
    },
    previewImage (id) {
      this.$store.commit('currentMemberId', id);
      this.$router.push('/appphoto');
    },
     fetchCurrentMember (payload) {
     
    db.collection('Census').doc(payload)
      .get()
      .then((doc) => {
        const form = {
             id: doc.id,
             imageUrl: doc.data().imageUrl,
             firstName: doc.data().firstName,
             lastName: doc.data().lastName,
             posteName: doc.data().posteName,
             accessCode: doc.data().accessCode,
             role: doc.data().role,
             phone: doc.data().phone,
             email: doc.data().email,
             dateOfBirth: doc.data().dateOfBirth,
             address: doc.data().address,
             gender: doc.data().gender,
             consent: doc.data().consent,
             city: doc.data().city,
             postalCode: doc.data().postalCode,
             isWithChildren: doc.data().isWithChildren,
             hasSmartPhone: doc.data().hasSmartPhone,
             noPhoneReason: doc.data().noPhoneReason,
             isBuyPhoneReady: doc.data().isBuyPhoneReady,
             maritalStatus: doc.data().maritalStatus,
             noVolunteerReason: doc.data().noVolunteerReason,
             isVolunteer: doc.data().isVolunteer,
             hasChildren: doc.data().hasChildren,
             volunteerFrequency: doc.data().volunteerFrequency,
             niveauScolaire: doc.data().niveauScolaire,
             churchName: doc.data().churchName,
             churchAttendance: doc.data().churchAttendance,
             memberSince: doc.data().memberSince,
             sermonTimeSpent: doc.data().sermonTimeSpent,
             isreferralReady: doc.data().isreferralReady,
             noReferralReason: doc.data().noReferralReason,
             isVolunteerReady: doc.data().isVolunteerReady,
             noVolunteerReason: doc.data().noVolunteerReason,
             volunteerTime: doc.data().volunteerTime,
             noDonationReason: doc.data().noDonationReason,
             donation: doc.data().donation,
             isDimeContribution: doc.data().isDimeContribution,
             isDonationReady: doc.data().isDonationReady,
             // dimeAmount: doc.data().dimeAmount,
             dime: doc.data().dime,
             dimeType: doc.data().dimeType,
             isOffrandeContribution: doc.data().isOffrandeContribution,
             // offrandeAmount: doc.data().offrandeAmount,
             offrandeType: doc.data().offrandeType,
             offrande: doc.data().offrande,
             isGraceContribution: doc.data().isGraceContribution,
             // graceDonationAmount: doc.data().graceDonationAmount,
             graceContributionType: doc.data().graceContributionType,
             isWorking: doc.data().isWorking,
             createdDate: doc.data().createdDate,
             isWorkReady: doc.data().isWorkReady,
             notAvailableReason: doc.data().notAvailableReason,
             isEducationReady: doc.data().isEducationReady,
             education: doc.data().education,
             isHouseOwner: doc.data().isHouseOwner,
             houseOwnerSince: doc.data().houseOwnerSince,
             isRenting: doc.data().isRenting,
             jobSkills: doc.data().jobSkills,
             jobSearch: doc.data().jobSearch,
             jobType: doc.data().jobType,
             availableTime: doc.data().availableTime,
             jobDisponibility: doc.data().jobDisponibility,
             timeOnCurrentJob: doc.data().timeOnCurrentJob,
             jobPosition: doc.data().jobPosition,
             numberOfJobs: doc.data().numberOfJobs,
             jobRepartition: doc.data().jobRepartition,
             jobWeeklyHours: doc.data().jobWeeklyHours,
             jobTravelDistance: doc.data().jobTravelDistance,
             homeTravelDistance: doc.data().homeTravelDistance,
             jobTravelMode: doc.data().jobTravelMode,            
             jobTravelCost: doc.data().jobTravelCost,
             jobTravelTime: doc.data().jobTravelTime,
             jobMonthlyPay: doc.data().jobMonthlyPay
        }  
         if (doc.data().imageUrl === "./src/assets/avatar.png" ) {
           form.imageUrl = memberPhoto;
         } else {
           this.$store.commit('memberPhoto', form.imageUrl)
         }
         if (
          doc.data().isBuyPhoneReady === null ||
          doc.data().isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = "Non";
         }
         if (
          doc.data().isVolunteerReady === null ||
          doc.data().isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = "Non";
         }
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
         ) {
           form.volunteerTime = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
          if (
          doc.data().houseOwnerSince === null ||
          doc.data().houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().offrande === null ||
          doc.data().offrande === undefined
         ) {
           form.offrande = {
            nombre: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().donation === null ||
          doc.data().donation === undefined
         ) {
           form.donation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().dime === null ||
          doc.data().dime === undefined
         ) {
           form.dime = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
          doc.data().timeOnCurrentJob === null ||
          doc.data().timeOnCurrentJob === undefined
         ) {
           form.timeOnCurrentJob = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
          if (
           
          doc.data().jobSearch === null ||
          doc.data().jobSearch === undefined
         ) {
           form.jobSearch = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().jobDisponibility === null ||
          doc.data().jobDisponibility === undefined
         ) {
           form.jobDisponibility = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
           if (
          doc.data().graceDonation === null ||
          doc.data().graceDonation === undefined
         ) {
           form.graceDonation = {
            amount: 0,
            frequency: 'Par jour'
           }
          }
         if (
          doc.data().education === null ||
          doc.data().education === undefined
         ) {
          form.education = {
            nombre: 0,
            frequency: 'Par jour'
           }
         }
         if (
          doc.data().numberOfKids === null ||
          doc.data().noPhoneReason === undefined
         ) {
           form.numberOfKids = 0;
         }
         if (
          doc.data().noReferralReason === null ||
          doc.data().noReferralReason === undefined
         ) {
           form.noReferralReason = 'Pas de raison';
         }
         if (
          doc.data().noDonationReason === null ||
          doc.data().noDonationReason === undefined
         ) {
           form.noDonationReason = 'Pas de raison';
         }
         if (
          doc.data().notAvailableReason === null ||
          doc.data().notAvailableReason === undefined
         ) {
           form.notAvailableReason = 'Pas de raison';
         }
         form.consent = true
          this.$store.commit('currentMember', form)
        })
      this.$router.push('/form/newmember')
    },
  },


};
</script>

<style lang="stylus" scoped>
  .caption, .subheading {
    font-weight:200;  
  }
</style>


// WEBPACK FOOTER //
// src/components/widgets/card/NameCardSearch.vue